/**
 * Clears the table data filters.
 */
export function dashboardMenu() {
  const $menuToggle = $('.m__dashboard-menu__toggle');
  if ($menuToggle) {
    $menuToggle.on('click', function (event) {
      $menuToggle.toggleClass('open');
    });
  }

  const $menuParents = $('.menu-item-has-children');
  $menuParents.each(function(index) {
    this.addEventListener('click', function(event) {

      if ( !event.target.parentElement.classList.contains('menu-item-has-children') ) {
        console.log('no child');
        return;
      }

      event.preventDefault();
      event.currentTarget.classList.toggle('open'); 
      console.log('child');
    });
  });
  

  function closeMenu(event) {
    $menuToggle.removeClass('open');
  }
}
